// utils/sentenceExtractor.js
export class SentenceExtractor {
  static extractContextAroundSelection(selectedText, fullText, selectionStartIndex) {
    if (!selectedText || !fullText) return { selectedText, contextBefore: '', contextAfter: '' };
    
    try {
      // Find the position of the selected text in the full text
      const startIndex = selectionStartIndex !== undefined ? selectionStartIndex : fullText.indexOf(selectedText);
      if (startIndex === -1) return { selectedText, contextBefore: '', contextAfter: '' };
      
      const endIndex = startIndex + selectedText.length;
      
      // Find sentence boundaries for context
      const contextStart = this.findSentenceStart(fullText, startIndex, 1); // 1 sentence before
      const contextEnd = this.findSentenceEnd(fullText, endIndex, 1); // 1 sentence after
      
      // Extract the three parts
      const contextBefore = fullText.substring(contextStart, startIndex).trim();
      const contextAfter = fullText.substring(endIndex, contextEnd).trim();
      
      return {
        selectedText: selectedText.trim(),
        contextBefore,
        contextAfter,
        fullContext: fullText.substring(contextStart, contextEnd).trim()
      };
    } catch (error) {
      console.error('Error extracting context:', error);
      return { selectedText, contextBefore: '', contextAfter: '' };
    }
  }
  
  static findSentenceStart(text, position, sentencesBefore = 1) {
    let sentenceCount = 0;
    let lastBoundary = 0;
    
    // Look backwards for sentence boundaries
    for (let i = position; i >= 0; i--) {
      const char = text[i];
      
      // Check for sentence boundaries
      if (char === '.' || char === '!' || char === '?') {
        // Skip whitespace after punctuation
        let j = i + 1;
        while (j < text.length && (text[j] === ' ' || text[j] === '\n' || text[j] === '\r' || text[j] === '\t')) {
          j++;
        }
        
        // If we found a boundary before our position
        if (j <= position) {
          sentenceCount++;
          lastBoundary = j;
          
          // If we've found the requested number of sentences before, return this boundary
          if (sentenceCount > sentencesBefore) {
            return lastBoundary;
          }
        }
      }
    }
    
    // If we didn't find enough sentences, return the beginning
    return lastBoundary;
  }
  
  static findSentenceEnd(text, position, sentencesAfter = 1) {
    let sentenceCount = 0;
    
    // Look forwards for sentence boundaries
    for (let i = position; i < text.length; i++) {
      const char = text[i];
      
      // Check for sentence boundaries
      if (char === '.' || char === '!' || char === '?') {
        sentenceCount++;
        
        // If we've found the requested number of sentences after, return this boundary
        if (sentenceCount >= sentencesAfter) {
          return i + 1; // Include the punctuation
        }
      }
    }
    
    // If we didn't find enough sentences, return the end
    return text.length;
  }
  
  static getFullPageText(textLayer) {
    if (!textLayer) return '';
    
    // Extract all text content from the PDF text layer
    const textNodes = textLayer.querySelectorAll('.react-pdf__Page__textContent span');
    let fullText = '';
    let currentPosition = 0;
    const nodePositions = [];
    
    textNodes.forEach(node => {
      const text = node.textContent || '';
      nodePositions.push({
        text: text,
        start: currentPosition,
        end: currentPosition + text.length,
        node: node
      });
      fullText += text + ' ';
      currentPosition += text.length + 1; // +1 for the space
    });
    
    return { fullText: fullText.trim(), nodePositions };
  }
  
  static findSelectionPosition(fullTextData, selectedText) {
    // Try to find the exact position in the full text
    const startIndex = fullTextData.fullText.indexOf(selectedText);
    if (startIndex !== -1) return startIndex;
    
    // If exact match fails, try fuzzy matching for the beginning
    const firstFewChars = selectedText.substring(0, Math.min(20, selectedText.length));
    const fuzzyStart = fullTextData.fullText.indexOf(firstFewChars);
    if (fuzzyStart !== -1) return fuzzyStart;
    
    return -1;
  }
}